import React from 'react';
import TablaLocalidades from '../../components/tables/Localidades';
const Localidades = () => {
    return (
        <TablaLocalidades/>
    );
}
 
export default Localidades;